import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@restworld/utils-common';
import { useRestaurantsService } from '@restworld/data-services';
import { useAuth } from '@restworld/feature-authentication';

function useEmployerRestaurantLocations(staleTime = Infinity) {
  const restaurantsService = useRestaurantsService();
  const { user } = useAuth();
  const organizationId = user?.organization_id;

  const query = useQuery({
    queryKey: [QUERY_KEYS.RESTAURANTS.LOCATIONS, organizationId],
    queryFn: () => restaurantsService.fetchLocalities({ organizationId }),
    enabled: !!organizationId,
    select: (data) => data.data.localities,
    staleTime,
  });

  return query;
}

export default useEmployerRestaurantLocations;
